import React, { useState } from 'react';

// The number is assembled only after a click, so it never appears in the page
// HTML or as a plain string in the JS bundle. Stops simple scrapers; a determined
// human can still click.
const PARTS = ['9804', '538', '014'];
const assemble = () => PARTS.map((p) => p.split('').reverse().join('')).reverse().join('');

const PhoneReveal = ({ label = 'Show phone number', className, style, as: Tag = 'button' }) => {
  const [digits, setDigits] = useState(null);

  if (digits) {
    const pretty = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    return (
      <a href={`tel:+1${digits}`} className={className} style={style}>
        {pretty}
      </a>
    );
  }

  return (
    <Tag type="button" onClick={() => setDigits(assemble())} className={className} style={style}>
      {label}
    </Tag>
  );
};

export default PhoneReveal;
